module.exports = "/images/discoverus-2.png";